const tempUserExclude = [
    "rupesh@holidaycharmeindia.com"
];

export {
    tempUserExclude
}